export const usePageSettings = (type: string | null | undefined, handle: string | null | undefined) => {
    const pageDataSettings = usePageData();
    pageDataSettings.value.type = toKebabCase(type || '');
    pageDataSettings.value.handle = toKebabCase(handle || '');
};
